import React, {useState} from "react";

const SingleChoiceBlock = ({config, onComplete}) => {

    const {
        prompt,
        options = [],
        correctOptionId,
        explanation
    } = config || {};

    const [selectedOptionId, setSelectedOptionId] = useState(null);
    const [isChecked, setIsChecked] = useState(false);


    const isCorrect =
        isChecked &&
        selectedOptionId === correctOptionId;


    const handleCheck = () => {

        if (!selectedOptionId || isChecked) {
            return;
        }

        setIsChecked(true);

        if (selectedOptionId === correctOptionId) {
            onComplete?.();
        }
    };


    return (
        <div className="w-full flex flex-col gap-5">

            {/* Question */}
            <div className="text-lg font-semibold leading-8">
                {prompt?.blocks?.map(block => (
                    <PromptBlock
                        key={block.id}
                        block={block}
                    />
                ))}
            </div>


            {/* Options */}
            <div className="flex flex-col gap-3">

                {options.map(option => {

                    const selected =
                        selectedOptionId === option.id;

                    const correct =
                        isChecked &&
                        option.id === correctOptionId;

                    const incorrect =
                        isChecked &&
                        selected &&
                        option.id !== correctOptionId;

                    return (
                        <button
                            key={option.id}
                            type="button"
                            disabled={isChecked}
                            onClick={() =>
                                setSelectedOptionId(option.id)
                            }
                            className={`
                                w-full
                                rounded-xl
                                border
                                p-4
                                text-right
                                transition
                                ${
                                correct
                                    ? "border-green-500 bg-green-50"
                                    : incorrect
                                        ? "border-red-500 bg-red-50"
                                        : selected
                                            ? "border-blue-500 bg-blue-50"
                                            : "border-gray-200 bg-white hover:border-gray-400"
                            }
                            `}
                        >
                            {option.text}
                        </button>
                    );
                })}

            </div>


            {/* Check */}
            {!isChecked && (
                <button
                    type="button"
                    disabled={!selectedOptionId}
                    onClick={handleCheck}
                    className="
                        w-full
                        rounded-xl
                        bg-black
                        px-5
                        py-3
                        text-white
                        disabled:opacity-40
                    "
                >
                    بررسی
                </button>
            )}


            {/* Result */}
            {isChecked && (
                <div
                    className={`
                        rounded-xl
                        p-4
                        leading-7
                        ${
                        isCorrect
                            ? "bg-green-50 text-green-800"
                            : "bg-red-50 text-red-800"
                    }
                    `}
                >

                    {isCorrect
                        ? "درست است!"
                        : "پاسخ اشتباه است."
                    }

                </div>
            )}


            {/* Explanation */}
            {isChecked && explanation?.blocks && (
                <div className="rounded-xl bg-gray-50 p-4">

                    {explanation.blocks.map(block => (
                        <PromptBlock
                            key={block.id}
                            block={block}
                        />
                    ))}

                </div>
            )}

        </div>
    );
};


/*
 * Prompt/explanation blocks are deliberately
 * kept simple for now.
 */
const PromptBlock = ({block}) => {

    if (block.type === "text") {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: block.config?.text || ""
                }}
            />
        );
    }

    return null;
};


export default SingleChoiceBlock;